export const gender = [
    {
        value: '1',
        label: 'Female',
        option: 'A',
        instruction: '',
    },
    {
        value: '2',
        label: 'Male',
        option: 'B',
        instruction: '',
    },
    {
        value: '3',
        label: 'Non-binary',
        option: 'C',
        instruction: '',
    },
    {
        value: '0',
        label: 'Prefer not to say',
        option: 'D',
        instruction: '',
    },
];
